import React from 'react';
import Entry from '../entry';
import { Text, Box } from 'rebass';
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import nyancatGIF from '../../gifs/nyancat.gif'

export default () => {
  const title = 'NyanShell';
  const hints = ['[Alabaster Snowball] sudo -l says I can run a command as root. What does it do?',
    '[Alabaster Snowball] On Linux, a user\'s shell is determined by the contents of /etc/passwd',
];
  const assignment = `Welcome to the Speaker UNpreparedness Room!
My name's Alabaster Snowball and I could use a hand.
I'm trying to log into this terminal, but something's gone horribly wrong.
Every time I try to log in, I get accosted with ... a hatted cat and a toaster pastry?
I thought my shell was Bash, not flying feline.
When I try to overwrite it with something else, I get permission errors.
Have you heard any chatter about immutable files? And what is sudo -l telling me?`;
  const data = useStaticQuery(graphql`
    query {
      cranNyan: file(relativePath: { eq: "cranNyan.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      nyanStart: file(relativePath: { eq: "nyanStart.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      nyanStep1: file(relativePath: { eq: "nyanStep1.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      nyanStep2: file(relativePath: { eq: "nyanStep2.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      nyanStep3: file(relativePath: { eq: "nyanStep3.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      nyanWin: file(relativePath: { eq: "nyanWin.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }


    }
  `)
  const extra = (
    <>
    <Img fluid={data.cranNyan.childImageSharp.fluid}
            style={{ margin: 0,  maxHeight: '35vh', width: '72vw' }}
            imgStyle={{ objectFit: 'contain' }}
    />
    <Text mb={1} fontSize='13px' alignSelf='center'>Location: Hermey Hall, Speaker Unpreparedness Room</Text>
    </>
  );

  return (
    <Entry
      title={title}
      hints={hints}
      extra={extra}
      assignment={assignment}
    >
      <Text my={2}>The challege gives us what we need to login as Alabaster. He needs some advice on password strength.</Text>
      <Img fluid={data.nyanStart.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '65vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>After all wrong attempts to login and land in bash we end up here: </Text>
      <Box><img height="60%" src={nyancatGIF} alt="nyancat rainbow" /></Box>
      <Text my={2}>Alabaster recommended that we check out this command.</Text>
      <Img fluid={data.nyanStep1.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>He also wanted us to look at <code>/etc/passwd</code></Text>
      <Img fluid={data.nyanStep2.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>So Alabaster's shell is nyanshell <code>/bin/nsh</code>. And we can use <code>chattr</code> to potentially change the nyanshell's attributes. Let's see what attibutes it has first.</Text>
      <Img fluid={data.nyanStep3.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>Alright! <code>/bin/nsh</code> is immutable. We can change that, and then override <code>nsh</code> with the contents of <code>bash</code> binary.</Text>
      <Img fluid={data.nyanWin.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
    </Entry>
  )

};
